import axios from "axios";
import { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import Modal from "../../../components/Modal/Modal";
import useAuth from "../../../hooks/useAuth";
import { BASE_URL } from "../../../utils/Element";
import AddKeyContractData from "./AddKeyContractData";

const initialData = {
  company_name: "",
  company: "",
  contact: "",
  sellers: [
    { seller_id: "", seller_name: "", seller_type: "" }
  ],
  buyers: [
    { buyer_id: "", buyer_name: "", buyer_type: "" }
  ],
};

const AddKeyContract = ({ showModal, onClose, onCallApi, id }) => {
  const [config] = useAuth();
  const [error, setError] = useState();
  const [disable, setDisable] = useState(false);
  const [formData, setFormData] = useState(initialData);
  const [search, setSearch] = useState("");

  const handleClose = () => {
    setFormData(initialData);
    onClose();
    setError();
    setDisable(false);
    setSearch("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setDisable(true);

    // 🔥 Prepare final payload
    const dataToSend = {
      company_name: formData.company_name,
      company: formData.company,
      contact: formData.contact,

      // 🔥 send full seller array with type
      sellers: Array.isArray(formData.sellers)
        ? formData.sellers.map((s) => ({
          seller_id: s.seller_id || "",
          seller_name: s.seller_name || "",
          seller_type: s.seller_type || "",
          type: s.seller_type === "Broker Inside" ? "user" : "contact"
        }))
        : [],

      // 🔥 send full buyer array with type
      buyers: Array.isArray(formData.buyers)
        ? formData.buyers.map((b) => ({
          buyer_id: b.buyer_id || "",
          buyer_name: b.buyer_name || "",
          buyer_type: b.buyer_type || "",
          type: b.buyer_type === "Broker Inside" ? "user" : "contact"
        }))
        : [],
    };

    axios
      .post(`${BASE_URL}/contract-to-close-keycontact/${id}`, dataToSend, config)
      .then(() => {
        handleClose();
        onCallApi();
      })
      .catch((err) => {
        setError(err.response?.data?.errors);
        if (
          err.response?.data?.message &&
          err.response?.data?.message !== "Too Many Attempts."
        ) {
          NotificationManager.error(err.response?.data?.message);
        }
      })
      .finally(() => setDisable(false));
  };

  useEffect(() => {
    if (!showModal || !id) return;

    axios
      .get(`${BASE_URL}/contract-to-close/${id}`, config)
      .then((res) => {
        const keyContact = res?.data?.data?.key_contact;
        if (!keyContact) return;

        // Group sellers by type
        const sellerGroups = {};
        (keyContact.seller_detail_with_type || []).forEach(s => {
          const type = s.type;
          const name = `${s.first_name} ${s.last_name}`.trim();
          if (!sellerGroups[type]) {
            sellerGroups[type] = {
              seller_id: [],
              seller_name: [],
              seller_type: type,
            };
          }
          sellerGroups[type].seller_id.push(s.id);
          sellerGroups[type].seller_name.push(name);
        });
        const sellers = Object.values(sellerGroups);

        // Group buyers by type
        const buyerGroups = {};
        (keyContact.buyer_detail_with_type || []).forEach(b => {
          const type = b.type;
          const name = `${b.first_name} ${b.last_name}`.trim();
          if (!buyerGroups[type]) {
            buyerGroups[type] = {
              buyer_id: [],
              buyer_name: [],
              buyer_type: type,
            };
          }
          buyerGroups[type].buyer_id.push(b.id);
          buyerGroups[type].buyer_name.push(name);
        });
        const buyers = Object.values(buyerGroups);

        setFormData({
          company_name: keyContact.agent_company_name?.name || "",
          company: keyContact.agent_company_id || "",

          contact: keyContact.agent
            ? {
              id: keyContact.agent.id,
              name: keyContact.agent.name,
            }
            : null,

          sellers: sellers.length ? sellers : initialData.sellers,
          buyers: buyers.length ? buyers : initialData.buyers,
        });
      })
      .catch((err) => {
        if (err.response?.data?.message) {
          NotificationManager.error(err.response.data.message);
        }
      });
  }, [showModal, id]);




  return (
    <Modal
      title={`Add Key Contract`}
      desc={`Add the Key Contract information.`}
      show={showModal}
      onClose={handleClose}
    >
      <AddKeyContractData
        formData={formData}
        error={error}
        onSetFormData={setFormData}
        onSetError={setError}
        handleSubmit={handleSubmit}
        handleClose={handleClose}
        search={search}
        showModal={showModal}
        disable={disable}
      />
    </Modal>
  );
};

export default AddKeyContract;